'use strict';

module.exports = /*@ngInject*/ function () {
    function ChartFactory() {

    }

    ChartFactory.prototype.createSimOverviewChart = function (chartArray, graphSet, axisSet) {
        return {
            "type": "serial",
            "pathToImages": "http://www.amcharts.com/lib/3/images/",
            "theme": "light",
            "legend": {
                "useGraphSettings": true,
                "valueWidth": 150,
                "autoMargins": true
            },
            "dataProvider": chartArray,
            "valueAxes": axisSet,
            "graphs": graphSet,
            "chartScrollbar": {},
            "chartCursor": {
                "categoryBalloonDateFormat": "DD MMMM",
                "cursorPosition": "mouse"
            },
            "categoryField": "timestamp",
            "categoryAxis": {
                "gridPosition": "start",
                "autoGridCount": true,
                "parseDates": true,
                "axisColor": "#DADADA"
            }
        }
    };

    return new ChartFactory();
};
